// extracted by mini-css-extract-plugin
export default {"mainContainer":"LoginAlreadyRegister_mainContainer__GXawz"};